import { buildExternalOffer, isCompleteCommerceItem, OfferSelectionContainer, } from '@themaven-net/commerce-shared';
import { html } from 'lit';
import { buildOfferButtonText, renderCommerceLink } from '../utility.js';
import BaseOfferAwareComponent from './baseOfferAwareComponent.js';
export default class BaseCommerceCta extends BaseOfferAwareComponent {
    constructor() {
        super(...arguments);
        this.defaultLinkClasses = '';
        this.adoptChildren = true;
        /**
         * The function used to render a link, replace this to alter output
         * @see renderCommerceLink
         */
        this.renderLink = renderCommerceLink;
    }
    get offerCount() {
        return 1;
    }
    get defaultButtonText() {
        return 'Get It At {Store}';
    }
    render() {
        this.selectOffers();
        const buttonContents = this.preExistingChildren.length === 0 ? this.buildDefaultButtonContents() : '';
        return html `
            <div class="m-commerce-cta noskim">
                <div class="m-commerce-cta--button appendTarget">${buttonContents}</div>
            </div>
        `;
    }
    /**
     * Build a commerce link based on config instead of using a slotted commerce-link
     */
    buildDefaultButtonContents() {
        if (this.config === undefined) {
            console.error('Unable to build Commerce CTA without a config');
            return undefined;
        }
        const offer = this.offerSelection?.primaryOffer;
        if (offer === undefined) {
            console.error('Unable to build Commerce CTA without a supplied offer or URL', this);
            return undefined;
        }
        const buttonText = this.getButtonText();
        const item = isCompleteCommerceItem(this.config.item) ? this.config.item : undefined;
        return this.renderLink(buttonText, offer, item, this.config?.options, false, {}, this.defaultLinkClasses);
    }
    /**
     * Select (or create from the config) an offer object to use
     */
    selectOffers() {
        if (this.config?.offer !== undefined) {
            this.offerSelection = new OfferSelectionContainer([this.config.offer], [], [], 1);
            return;
        }
        if (this.config?.link !== undefined) {
            const offer = buildExternalOffer(this.config.link);
            this.offerSelection = new OfferSelectionContainer([offer], [], [], 1);
            return;
        }
        super.selectOffers();
    }
    /**
     * Determine the proper text to use in the button contents if rendering from config
     *
     * Order of choice:
     *    config ctaText -> selecting text from item offer config -> default button text
     */
    getButtonText() {
        const offer = this.offerSelection?.primaryOffer;
        if (offer === undefined) {
            console.log('Cannot get button text without an offer');
            return '';
        }
        if (this.config?.ctaText !== undefined && this.config?.ctaText !== '') {
            // we should not do text replacement on manually specified text
            return this.config.ctaText;
        }
        return buildOfferButtonText(offer, this.config?.options?.buttonTitleByIdentifier ?? {}, this.defaultButtonText);
    }
}
//# sourceMappingURL=baseCommerceCta.js.map